/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/9/22
 */

import {gql} from "urql";
import {VegaEvent, SubscriptionResponse} from "../../interfaces/Global";

export const CalendarEventsSubscription = gql`
    subscription CalendarEvents($employees: [String!]!, $from: Date, $to: Date) {
        calendarEvents(employees: $employees, from: $from, to: $to) {
            event
	        data {
                id
                createdBy
                createdByEmployee {
                    id
                    displayName
                }
                creationDate
                modifiedBy
                modifiedByEmployee {
                    id
                    displayName
                }
                modifiedDate
                vstamp
		        employeeId
                employee {
                    id
                    displayName
                }
                typeId
                startDatetime
                endDatetime
                isConfirmed
                confirmationDate
                confirmedBy
                confirmedByEmployee {
                    id
                    displayName
                }
                description
		        capacityModifier
		        properties
            }
        }
    }
`;

export interface CalendarEventsSubscriptionResponse {
	calendarEvents: SubscriptionResponse<VegaEvent>
}

export interface CalendarEventsSubscriptionVars {
	employees: string[]
	from: Date
	to: Date
}